import { Check, X } from "lucide-react";
import { passwordLevel, passwordRules } from "@/lib/passwordPolicy";

const BARS = { Debole: 1, Media: 2, Forte: 3 };

export const PasswordStrength = ({ id, password, email }) => {
    const rules = passwordRules(password || "", email);
    const level = passwordLevel(password || "", email);
    return (
        <div id={id} className="mt-2 rounded-lg border border-edi-border bg-edi-bg p-3 text-sm" data-testid={`${id}`}>
            <div className="flex items-center gap-3">
                <div className="flex gap-1" aria-hidden="true">
                    {[1, 2, 3].map((n) => <span key={n} className={`h-1.5 w-8 rounded-full ${password && n <= BARS[level] ? "bg-edi-text" : "bg-edi-border"}`} />)}
                </div>
                <p aria-live="polite" className="font-semibold" data-testid={`${id}-level`}>Robustezza: {password ? level : "—"}</p>
            </div>
            <ul className="mt-2 grid gap-1 sm:grid-cols-2" aria-live="polite" aria-label="Requisiti della password" data-testid={`${id}-rules`}>
                {rules.map((r) => (
                    <li key={r.key} className={`flex items-center gap-2 ${r.ok ? "text-edi-text" : "text-edi-muted"}`} data-testid={`${id}-rule-${r.key}`} data-ok={r.ok}>
                        {r.ok ? <Check aria-hidden="true" size={16} className="shrink-0" /> : <X aria-hidden="true" size={16} className="shrink-0" />}
                        <span><span className="sr-only">{r.ok ? "Rispettato: " : "Non rispettato: "}</span>{r.label}</span>
                    </li>
                ))}
            </ul>
            <p className="mt-1 text-xs text-edi-muted">Le password troppo comuni vengono rifiutate.</p>
        </div>
    );
};
